import React from "react";
import { Transactions } from "../../../../components/Shifts";

class ShiftsTransactionScreen extends React.Component {
  render() {
    return (
      <div>
        <Transactions />
      </div>
    );
  }
}

export default ShiftsTransactionScreen;
